import React from 'react'
import { ButtonBase, Typography } from '@mui/material'
import RowStack from 'components/atoms/container/RowStack'
import colors from 'styles/colors'

const StyledTabs = ({ tabs, activeTab, setActiveTab, containerProps }) => {
  return (
    <RowStack spacing={4} flexWrap={'wrap'}>
      {tabs.map(tab => (
        <ButtonBase
          key={tab.value}
          onClick={() => setActiveTab(tab.value)}
          {...containerProps}>
          <RowStack
            spacing={2}
            sx={{
              borderRadius: 2,
              paddingY: 6,
              paddingLeft: 8,
              paddingRight: 10,
              justifyContent: 'center',
              backgroundColor:
                activeTab === tab.value
                  ? tab.color || colors.Grey100
                  : colors.Transparent,
              '&:hover': {
                backgroundColor: colors.Grey100
              }
            }}>
            {tab.icon}
            <Typography variant='buttonLarge'>{tab.label}</Typography>
          </RowStack>
        </ButtonBase>
      ))}
    </RowStack>
  )
}

export default StyledTabs
